// src/store/showcase/state.js
export default {
  drawerState: ''
};
